
<script>
	import listBase from '@_system/components/base/list.vue'
	import importTable from '@_system/components/import/index.vue'
	export default {
		extends: listBase,
		name: 'administrationimprestIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<importTable ref={this.importRef} moduleName={this.importModuleName} importpredata={this.importpredata}  />
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				importpredata:[],
				importRef: Math.random(),
				importModuleName:null,
				moduleName: 'administrationimprest',
				windowName: '行政备用金',
				windowType: 'modal',
				currentrow:null,
				list_footerField:[
					{field:'amt',toFixed:2}
				],
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500,2000],
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

			
		},
		computed: {

		},

		methods: {
			applyimprest(){
				let data = this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let amount = 0
				let serialNo = data.map((item)=>{
					amount += parseFloat(item.amt)
					return item.serialNo
				})
				let flowid = 36
				this.$api.flow.getSingleFlowTemplate(flowid).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: 'transferaccounts',								
								id: 0,
								controlltype: 1,
								windowName: '备用金转账',
								extra: JSON.stringify({
									sourceordercode: serialNo.join(','),
									amount:amount,
									rcvAcc:'Wenzjinx@163.com',
									uses:10018
								}),
								isflow: 1,
								flowid: flowid
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, this.moduleName + "add",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log(this.moduleName + 'form open')
							}
						}
							
					}
				})
			},
			tocostorder(){
				let data =  this.$refs[this.moduleName+'_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}	
				this.createcostorder(data)
			},
			createcostorder(row){
				if(!Array.isArray(row)){
					row = [row]
				}
				this.importpredata = row.map((item)=>{
					let company = window.systemData.company.find((_item)=>{
						return _item.name == item.accName
					})
					return {
						'main|bankAcc':item.bankAcc,
						'main|rcvAcc':item.oppAccNo,
						'main|serialId':item.serialId,
						'main|paymenttime':item.transTime,
						'main|biztime':item.transTime,
						'main|companyid':company?company.id:null,
						'costorder_detail|businessdepartmentid':null,
						'costorder_detail|costamount':item.cdSign == 0 ? -item.amt : item.amt
					}
				})
				this.importModuleName = 'costorder'
				this.$refs[this.importRef].importpanel()
			},
			// importcomfig(){
			// 	return new Promise((reslove)=>{
			// 		let res = [
			// 			{code:'serialId',title:'序列号ID',require:true},
			// 			{code:'serialNo',title:'关联单据'}
			// 		]
			// 		reslove(res)
			// 	})
			// },
		},
		components: {
			importTable	
		}
	}
</script>
